<template>
  <div name="demo-chart-bubble">
  	chart bubble
  </div>
</template>

<script>
export default {
  name: 'demo-chart-bubble'
}
</script>


// WEBPACK FOOTER //
// demoChartBubble.vue?9ebc73d6